import React from "react";

const useModal = () => {
  const [show, setShow] = React.useState(false);

  const onToggle = React.useCallback(() => {
    setShow((prev) => !prev);
  }, []);

  const onShow = React.useCallback(() => {
    setShow(true);
  }, []);

  const onClose = React.useCallback(() => {
    setShow(false);
  }, []);

  return React.useMemo(() => {
    return {
      show,
      onClose,
      onShow,
      onToggle,
    };
  }, [show, onClose, onShow, onToggle]);
};

export default useModal;
